import { type Components, type Theme } from "@mui/material/styles";

import { muiAvatarOverrides } from "./overrides/avatar";
import { muiBadgeOverrides } from "./overrides/badge";
import { muiButtonOverrides } from "./overrides/button";
import { muiButtonBaseOverrides } from "./overrides/buttonBase";
import { muiScrollbarOverrides } from "./overrides/scrollbar";
import { muiSwitchOverrides } from "./overrides/switch";
import { muiTabsOverrides } from "./overrides/tabs";

export const muiThemeComponents: Components<Theme> = {
  ...muiButtonOverrides,
  ...muiButtonBaseOverrides,
  ...muiAvatarOverrides,
  ...muiBadgeOverrides,
  ...muiTabsOverrides,
  ...muiScrollbarOverrides,
  ...muiSwitchOverrides,
};
